import { useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
} from "react-bootstrap";

import {
  REFERENSSI_KOHTEET,
  REFERENSSI_TUOTTEET,
} from "../../assets/referenssiOptions";

const GREEN = "#04aa00";

const EMPTY_REFERENSSI = {
  kohde: "",
  tilaaja: "",
  tuote: "",
  toteutusvuosi: "",
};

const isCustomValue = (
  value,
  options
) => {
  if (!value) return false;

  return !options.includes(value);
};

function SelectOrCustomInput({
  label,
  value,
  options,
  placeholder,
  customPlaceholder,
  onChange,
}) {
  const [customMode, setCustomMode] =
    useState(
      isCustomValue(
        value,
        options
      )
    );

  const handleSelectChange = (
    event
  ) => {
    const nextValue =
      event.target.value;

    if (
      nextValue === "__MUU__"
    ) {
      setCustomMode(true);
      onChange("");
      return;
    }

    onChange(nextValue);
  };

  if (customMode) {
    return (
      <Form.Group>
        <Form.Label
          style={{
            fontSize: "12px",
            fontWeight: "700",
            color: "#6c757d",
          }}
        >
          {label}
        </Form.Label>

        <div className="d-flex gap-2">
          <Form.Control
            autoFocus
            value={value || ""}
            placeholder={
              customPlaceholder
            }
            style={{
              borderRadius: "8px",
            }}
            onChange={(event) =>
              onChange(
                event.target.value
              )
            }
          />

          <Button
            type="button"
            size="sm"
            variant="outline-secondary"
            title="Palaa valintaan"
            onClick={() => {
              setCustomMode(false);
              onChange("");
            }}
          >
            ↩
          </Button>
        </div>
      </Form.Group>
    );
  }

  return (
    <Form.Group>
      <Form.Label
        style={{
          fontSize: "12px",
          fontWeight: "700",
          color: "#6c757d",
        }}
      >
        {label}
      </Form.Label>

      <Form.Select
        value={value || ""}
        style={{
          borderRadius: "8px",
        }}
        onChange={
          handleSelectChange
        }
      >
        <option value="">
          {placeholder}
        </option>

        {options.map(
          (option) => (
            <option
              key={option}
              value={option}
            >
              {option}
            </option>
          )
        )}

        <option value="__MUU__">
          Muu
        </option>
      </Form.Select>
    </Form.Group>
  );
}

function ReferenceSection({
  title,
  description,

  items,
  setItems,

  setDeletedIds,
}) {
  const [
    editingIndex,
    setEditingIndex,
  ] = useState(null);

const addItem = () => {
  setItems((previous) => {
    const newIndex =
      previous.length;

    setEditingIndex(
      newIndex
    );

    return [
      ...previous,
      {
        ...EMPTY_REFERENSSI,
        jarjestys: newIndex,
      },
    ];
  });
};

  const updateItem = (
    index,
    field,
    value
  ) => {
    setItems((previous) =>
      previous.map(
        (item, itemIndex) =>
          itemIndex === index
            ? {
                ...item,
                [field]: value,
              }
            : item
      )
    );
  };

  const deleteItem = (
    item,
    index
  ) => {
    const confirmed =
      window.confirm(
        "Haluatko varmasti poistaa referenssin?"
      );

    if (!confirmed) return;

    if (
      item.id &&
      setDeletedIds
    ) {
      setDeletedIds(
        (previous) => [
          ...previous,
          item.id,
        ]
      );
    }

   setItems((previous) =>
  previous
    .filter(
      (_, itemIndex) =>
        itemIndex !== index
    )
    .map(
      (item, newIndex) => ({
        ...item,
        jarjestys: newIndex,
      })
    )
);

    setEditingIndex(null);
  };

  const moveItem = (
  fromIndex,
  toIndex
) => {
  if (
    toIndex < 0 ||
    toIndex >= items.length ||
    fromIndex === toIndex
  ) {
    return;
  }

  setItems((previous) => {
    const next = [
      ...previous,
    ];

    const [moved] =
      next.splice(
        fromIndex,
        1
      );

    next.splice(
      toIndex,
      0,
      moved
    );

    return next.map(
      (item, index) => ({
        ...item,
        jarjestys: index,
      })
    );
  });

  setEditingIndex(
    (current) => {
      if (current === null) {
        return current;
      }

      if (
        current === fromIndex
      ) {
        return toIndex;
      }

      if (
        fromIndex < toIndex &&
        current > fromIndex &&
        current <= toIndex
      ) {
        return current - 1;
      }

      if (
        fromIndex > toIndex &&
        current >= toIndex &&
        current < fromIndex
      ) {
        return current + 1;
      }

      return current;
    }
  );
};

  return (
    <div className="mb-5">
      <div
        className="d-flex justify-content-between align-items-center mb-4 pb-3"
        style={{
          borderBottom:
            "1px solid #e8eee8",
        }}
      >
        <div>
          <h5
            className="mb-1"
            style={{
              color:
                "#264d26",

              fontWeight:
                "700",
            }}
          >
            {title}
          </h5>

          <div
            className="text-muted"
            style={{
              fontSize:
                "13px",
            }}
          >
            {description}
          </div>
        </div>

        <Button
          type="button"
          size="sm"
          onClick={addItem}
          style={{
            backgroundColor:
              GREEN,

            borderColor:
              GREEN,

            borderRadius:
              "8px",
          }}
        >
          + Lisää referenssi
        </Button>
      </div>

      {items.length === 0 ? (
        <div
          className="text-center text-muted py-5"
          style={{
            backgroundColor:
              "#fafcfa",

            border:
              "1px dashed #cddacd",

            borderRadius:
              "12px",
          }}
        >
          Ei lisättyjä
          referenssejä.
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {items.map(
            (
              item,
              index
            ) => {
              const isEditing =
                editingIndex ===
                index;

              return (
                <div
                  key={
                    item.id ||
                    `referenssi-${index}`
                  }
                  style={{
                    border:
                      "1px solid #e3e9e3",

                    borderLeft:
                      `5px solid ${GREEN}`,

                    borderRadius:
                      "12px",

                    backgroundColor:
                      "#ffffff",

                    boxShadow:
                      "0 3px 10px rgba(0,0,0,0.06)",

                    overflow:
                      "hidden",
                  }}
                >
                  {/* HEADER */}

                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      padding:
                        "12px 16px",

                      backgroundColor:
                        "#f7fbf7",

                      borderBottom:
                        "1px solid #e7ece7",
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width:
                            "30px",

                          height:
                            "30px",

                          borderRadius:
                            "50%",

                          backgroundColor:
                            GREEN,

                          color:
                            "#ffffff",

                          fontWeight:
                            "700",

                          fontSize:
                            "13px",

                          flexShrink:
                            0,
                        }}
                      >
                        {index +
                          1}
                      </div>

                      <div>
                        <div
                          className="fw-semibold"
                          style={{
                            color:
                              "#315b31",
                          }}
                        >
                          {item.kohde ||
                            "Uusi referenssi"}
                        </div>

                        <div
                          className="text-muted"
                          style={{
                            fontSize:
                              "12px",
                          }}
                        >
                          {item.tuote ||
                            item.tilaaja ||
                            "Tietoja ei määritetty"}

                          {item.toteutusvuosi
                            ? ` • ${item.toteutusvuosi}`
                            : ""}
                        </div>
                      </div>
                    </div>

                    <div className="d-flex gap-2">
                      <Button
                        type="button"
                        size="sm"
                        variant="outline-secondary"
                        disabled={
                          index ===
                          0
                        }
                        onClick={() =>
                          moveItem(
                            index,
                            index -
                              1
                          )
                        }
                      >
                        ↑
                      </Button>

                      <Button
                        type="button"
                        size="sm"
                        variant="outline-secondary"
                        disabled={
                          index ===
                          items.length -
                            1
                        }
                        onClick={() =>
                          moveItem(
                            index,
                            index +
                              1
                          )
                        }
                      >
                        ↓
                      </Button>

                      <Button
                        type="button"
                        size="sm"
                        variant="outline-secondary"
                        style={
                          isEditing
                            ? {
                                backgroundColor:
                                  GREEN,

                                borderColor:
                                  GREEN,

                                color:
                                  "#ffffff",
                              }
                            : {}
                        }
                        onClick={() =>
                          setEditingIndex(
                            isEditing
                              ? null
                              : index
                          )
                        }
                      >
                        {isEditing
                          ? "Valmis"
                          : "Muokkaa"}
                      </Button>

                      <Button
                        type="button"
                        size="sm"
                        variant="outline-danger"
                        onClick={() =>
                          deleteItem(
                            item,
                            index
                          )
                        }
                      >
                        Poista
                      </Button>
                    </div>
                  </div>

                  {/* CONTENT */}

                  <div
                    style={{
                      padding:
                        "16px",
                    }}
                  >
                    {isEditing ? (
                      <Row className="g-3">
                        <Col md={3}>
                          <SelectOrCustomInput
                            label="Kohde"
                            value={
                              item.kohde
                            }
                            options={
                              REFERENSSI_KOHTEET
                            }
                            placeholder="Valitse kohde"
                            customPlaceholder="Kirjoita muu kohde"
                            onChange={(
                              value
                            ) =>
                              updateItem(
                                index,
                                "kohde",
                                value
                              )
                            }
                          />
                        </Col>

                        <Col md={3}>
                          <Form.Group>
                            <Form.Label
                              style={{
                                fontSize:
                                  "12px",

                                fontWeight:
                                  "700",

                                color:
                                  "#6c757d",
                              }}
                            >
                              Tilaaja
                            </Form.Label>

                            <Form.Control
                              value={
                                item.tilaaja ||
                                ""
                              }
                              style={{
                                borderRadius:
                                  "8px",
                              }}
                              onChange={(
                                event
                              ) =>
                                updateItem(
                                  index,
                                  "tilaaja",
                                  event
                                    .target
                                    .value
                                )
                              }
                            />
                          </Form.Group>
                        </Col>

                        <Col md={4}>
                          <SelectOrCustomInput
                            label="Tuote"
                            value={
                              item.tuote
                            }
                            options={
                              REFERENSSI_TUOTTEET
                            }
                            placeholder="Valitse tuote"
                            customPlaceholder="Kirjoita muu tuote"
                            onChange={(
                              value
                            ) =>
                              updateItem(
                                index,
                                "tuote",
                                value
                              )
                            }
                          />
                        </Col>

                        <Col md={2}>
                          <Form.Group>
                            <Form.Label
                              style={{
                                fontSize:
                                  "12px",

                                fontWeight:
                                  "700",

                                color:
                                  "#6c757d",
                              }}
                            >
                              Toteutusvuosi
                            </Form.Label>

                            <Form.Control
                              type="number"
                              value={
                                item.toteutusvuosi ||
                                ""
                              }
                              style={{
                                borderRadius:
                                  "8px",
                              }}
                              onChange={(
                                event
                              ) =>
                                updateItem(
                                  index,
                                  "toteutusvuosi",
                                  event
                                    .target
                                    .value
                                )
                              }
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    ) : (
                      <Row className="g-3">
                        <Col md={3}>
                          <div
                            className="text-muted fw-semibold"
                            style={{
                              fontSize:
                                "12px",
                            }}
                          >
                            Kohde
                          </div>

                          <div>
                            {item.kohde ||
                              "–"}
                          </div>
                        </Col>

                        <Col md={3}>
                          <div
                            className="text-muted fw-semibold"
                            style={{
                              fontSize:
                                "12px",
                            }}
                          >
                            Tilaaja
                          </div>

                          <div>
                            {item.tilaaja ||
                              "–"}
                          </div>
                        </Col>

                        <Col md={4}>
                          <div
                            className="text-muted fw-semibold"
                            style={{
                              fontSize:
                                "12px",
                            }}
                          >
                            Tuote
                          </div>

                          <div>
                            {item.tuote ||
                              "–"}
                          </div>
                        </Col>

                        <Col md={2}>
                          <div
                            className="text-muted fw-semibold"
                            style={{
                              fontSize:
                                "12px",
                            }}
                          >
                            Toteutusvuosi
                          </div>

                          <div>
                            {item.toteutusvuosi ||
                              "–"}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              );
            }
          )}
        </div>
      )}
    </div>
  );
}

export default function ReferenssitEditor({
  referenssit = [],
  setReferenssit,

  deletedReferenssit = [],
  setDeletedReferenssit,

  yritysReferenssit = [],
  setYritysReferenssit,

  deletedYritysReferenssit = [],
  setDeletedYritysReferenssit,

  showPersonal = true,
  showCompany = true,
}) {
  return (
    <>
      {showPersonal && (
        <ReferenceSection
          title="Henkilön referenssit"
          description="Käyttäjän omat projektireferenssit."
          items={
            referenssit
          }
          setItems={
            setReferenssit
          }
          deletedIds={
            deletedReferenssit
          }
          setDeletedIds={
            setDeletedReferenssit
          }
        />
      )}

      {showCompany && (
        <ReferenceSection
          title="Yrityksen referenssit"
          description="Yrityksen yhteiset projektireferenssit."
          items={
            yritysReferenssit
          }
          setItems={
            setYritysReferenssit
          }
          deletedIds={
            deletedYritysReferenssit
          }
          setDeletedIds={
            setDeletedYritysReferenssit
          }
        />
      )}
    </>
  );
}